var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-mission"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('join.mission')))]),_c('h4',[_vm._v(_vm._s(_vm.$t('join.missionText')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }